// @dynamic-i18n-keys
// pages.about.navmenu.*
// pages.stats.widgets.*
import type { ReactNode } from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-ds/pkg/Sticky';
import { Nav } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';

import s from './SideNavBar.scss';

const BOTTOM_MARGIN = 60;

export interface SidebarRoute {
  hash: string;
  transKey: string;
  count?: string;
}

export interface SideNavBarProps {
  routes: SidebarRoute[];
  activeHash?: string;
  onActiveHashChange: (activeHash: string) => void;
  className?: string;
  biEvid: number;
  heading: ReactNode;
}

function SideNavBar(props: SideNavBarProps) {
  const { t } = useTranslation();
  const marginTop = 144;
  const { routes, className, activeHash, onActiveHashChange, biEvid, heading } = props;

  return (
    <ErrorBoundary debugComponent="SideNavBar" hideOnFail>
      <div className={s['root']}>
        <Sticky
          zIndex={parseInt(s['z-index'], 10)}
          marginTop={marginTop}
          className={s['sticky']}
          bottomStop={parseInt(s['footerHeight'], 10) + BOTTOM_MARGIN}
        >
          {isStuck => (
            <Nav className={classnames(s['nav-sidebar'], isStuck && s['sticky'], className)}>
              {heading}
              {routes.map(route => (
                <BiLink
                  biData={
                    {
                      evid: biEvid,
                      menu_item_name: route.hash,
                    } as any
                  }
                  key={route.hash}
                  href={`#${route.hash}`}
                  className={classnames(
                    s['nav-link-item'],
                    activeHash && activeHash === route.hash && s['active']
                  )}
                  onClick={e => {
                    onActiveHashChange(route.hash);
                  }}
                >
                  {t(route.transKey)}
                  <span className={s['count']}>
                    {route.count && parseInt(route.count, 10) > 0 ? route.count : ''}
                  </span>
                </BiLink>
              ))}
            </Nav>
          )}
        </Sticky>
      </div>
    </ErrorBoundary>
  );
}

export default SideNavBar;
